import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import ActionMessageButton from "../general/ActionMessageButton";
import { getBrokerInformation } from "../store/broker";
import { updateProspectStatus } from "../store/qf";
import ReactLoading from "react-loading";
import FormControl from "@material-ui/core/FormControl";
import DropdownButton from "react-bootstrap/DropdownButton";
import Dropdown from "react-bootstrap/Dropdown";
import _ from "lodash";
import PdfSettingsModal from "../components/PdfSettingsModal";

import {
  getPDFV2fromURL,
  bindModalOpened,
  getBindModalState,
  getPDFV2status,
  getPDFOnlyStatus,
  getBindQuoteConformationModalState,
  openBindQuoteConformationModal,
  closeBindQuoteConformationModal,
  setautoreminder,
} from "../store/components";
import {
  getIRS,
  getIRSAPP,
  getIRSCodeOnly,
  getProspectid,
  getSelectedInsurerEmails,
  getShowingSendToInsurers,
  getStiEmailData,
  getResponseDetails,
  getProspectDetails,
  getInsurerOrder,
  getInsurerOrderRemaining,
  getInsurerDetails,
  updateInsurerOrder,
  updateInsurerOrderInverse,
  getTotalSelected,
  updateSTCModalStatus,
  getSTCModalStatus,
  getPolicyJustBinded,
} from "../store/quotes";
import * as theme from "../theme";
import ActionCentreText from "./ActionCetreText";
import Modal from "react-modal";
import CancelIcon from "@material-ui/icons/Cancel";
import Form from "react-bootstrap/Form";
import BindModal from "../components/BindModal";
import BindQuoteConformationModal from "../components/BindQuoteConformationModal";
import SendToClientModal from "./SendToClientModal";
import { TotalNumberOfComparisonInsurerPDFCanHandle } from "../store/businesslogic/hardwiredlogic";
import { PossibleApiStatusValues } from "../store/helperfuncs";
import { getFormState, verifyBrokerAgainstProspectQF,getProspectDoc } from "../store/qf";
import { getGettingMyQuotesSuccess, getRowDetailsFromProspectId } from "../store/myquotes";
import externalTranslations from "../utils/translations";


const goToMarketPermission = "goToMarket";
const bindPermission = "bind";

const RightPaneActions = (props) => {
  const showingSendToInsurers = useSelector(getShowingSendToInsurers);
  const bindModalState = useSelector(getBindModalState);
  const bindQuoteConformationModalState = useSelector(
    getBindQuoteConformationModalState
  );
  const irsCodeOnly = useSelector(getIRSCodeOnly);
  const gotResponseDetails = useSelector(getResponseDetails);
  const gotProspectDetails = useSelector(getProspectDetails);
  const formstate = useSelector(getFormState);
  const prospectDoc = useSelector(getProspectDoc)
  const asArray = Object.values(gotResponseDetails);
  const validateBeforeSendBind = asArray.filter(
    (data) => data.checkedforcompare === true
  );
  const irs = useSelector(getIRS);
  const irsapp = useSelector(getIRSAPP);
  let emaillist = useSelector(getSelectedInsurerEmails);
  const stiEmailData = useSelector(getStiEmailData);
  const insurerorder = useSelector(getInsurerOrder);
  const insurerorderInverse = useSelector(getInsurerOrderRemaining);
  const [initial_insureorder, setinitial_insureorder] = React.useState([
    ...insurerorder,
  ]);
  const [modalObj, setModalObj] = React.useState({ show: false });
  const [submissionEmailData,setSubmissionEmailData] = useState({})
  const [initial_insureorderInverse, setinitial_insureorderInverse] =
    React.useState([...insurerorderInverse]);
  let { information } = useSelector(getBrokerInformation);
  const languagepreference = information.languagepreference;
  let { brokerages, user, phonenumber } = information;

  let { email, name } = user;

  let brokeragename = brokerages[0].name;
  const dispatch = useDispatch();
  const prospectid = useSelector(getProspectid);
  const gettingMyQuotesSucceed = useSelector(getGettingMyQuotesSuccess);
  const prospectDetails = useSelector(getRowDetailsFromProspectId({ prospectid }));

  const [windowSize, setWindowSize] = useState(window.innerWidth);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const translations = {
    en: {
      productComparison: {
        noSelection:
          "Product Comparison: Please Select products from the list to run a multi-insurer product comparison.",
        selectionMade:
          "Product Comparison: Select products from the list to run a multi-insurer product comparison",
        buttonText: "Compare Products", // Assuming buttonTextDecider function logic
      },
      insurerSubmission: {
        text: "Insurer Submission: Regardless of quotes, send the completed app to various insurers",
        buttonText: "Send to Market",
      },
      sendToClient: {
        text: "Send to Client: Create a client presentation at the click of a button",
        buttonText: "Create Client Presentation",
      },
      downloadPDF: {
        text: "Download a PDF containing all the application questions and answers",
        buttonText: "Download application PDF",
      },
      editPDFOptions: "Edit PDF Options",
      downloadPDFButtonText: "Download PDF",

      // **New Translation Keys**
      externalLink: {
        text: "Create and copy a link that you can send to insurers which provides them with a non-editable view of the client’s application in Quotey",
        buttonText: "Get external link to Quotey screens",
      },
      sendToSelectedInsurers: "Send to selected insurers",
      createEmailWithApplication: "Create email with application",

      viewOrCompare: "View or Compare",
      compareSelectedProducts: "Compare Selected Products",
      viewSelectedProduct: "View Selected Product",
      searchForInsurer: "Search for an Insurer",
    },
    fr: {
      searchForInsurer: "Rechercher",
      viewOrCompare: "Voir ou Comparer",
      compareSelectedProducts: "Comparer les Produits Sélectionnés",
      viewSelectedProduct: "Voir le Produit Sélectionné",
      productComparison: {
        noSelection:
          "Comparaison de produits : Veuillez sélectionner des produits de la liste pour exécuter une comparaison de produits multi-assureurs.",
        selectionMade:
          "Comparaison de produits : Sélectionnez des produits de la liste pour exécuter une comparaison de produits multi-assureurs",
        buttonText: "Comparer les produits", // Assuming buttonTextDecider function logic
      },
      aiRecommendation: {
        text: "Recommandation IA : indépendamment des devis, envoyez la proposition d'assurance complétée à différents assureurs pour obtenir une recommandation IA",
        buttonText: "Obtenez une recommandation d'IA",
      },
      quoteAnalysis: {
        text: "Analyse des devis : Indépendamment des devis, envoyez la proposition d'assurance complétée à divers assureurs pour une analyse des devis",
        buttonText: "Analyse des devis",
      },
      renewalAnalysis: {
        text: "Analyse de renouvellement : Indépendamment des devis, envoyez le formulaire de demande dûment rempli à différents assureurs pour analyse de renouvellement",
        buttonText: "Analyse des renouvellement",
      },
      insurerSubmission: {
        text: "Soumission à l'assureur : Indépendamment des devis, envoyer la proposition d'assurance complétée à divers assureurs",
        buttonText: "Envoyer au marché",
      },
      sendToClient: {
        text: "Envoyer au client : Créer une présentation client en un clic",
        buttonText: "Créer une présentation client",
      },
      downloadPDF: {
        text: "Télécharger un PDF contenant toutes les questions et réponses de la proposition d'assurance",
        buttonText: "PDF de la proposition d'assurance",
      },
      editPDFOptions: "Modifier les options PDF",
      downloadPDFButtonText: "Télécharger le PDF",

      // **New Translation Keys**
      externalLink: {
        text: "Créez et copiez un lien que vous pouvez envoyer aux assureurs, leur offrant une vue non modifiable de la demande du client dans Quotey",
        buttonText: "Obtenir le lien externe vers les écrans Quotey",
      },
      sendToSelectedInsurers: "Envoyer aux assureurs sélectionnés",
      createEmailWithApplication: "Créer un email avec la demande",
    },
  };

  React.useEffect(() => {
    if (prospectid) {
      dispatch(
        verifyBrokerAgainstProspectQF({
          prospectid: prospectid,
        })
      );
    }
  }, [dispatch, prospectid]);

  function findRenewalData(prospectDoc) {
    const renewalKeys = ['10507c', '10507f', '11007', '11007a', '11009'];
  
    const cleanedAnswers = prospectDoc?.cleanedanswers;
  
    if (!cleanedAnswers || typeof cleanedAnswers !== 'object') {
      console.warn("prospectDoc.cleanedanswers is missing or not an object.");
      return ""; 
    }
  
    for (const key of renewalKeys) {
 
      if (key in cleanedAnswers) {
      
        return cleanedAnswers[key];
      }
    }
  
    return "";
  }

  function userHasPermission(action) {
    const permissions = information?.permissions;

    const hasPermission = _.findIndex(permissions, { value: action });

    if (hasPermission === -1) {
      return false;
    } else {
      return true;
    }
  }

  let common = {
    display: "flex",
    flexDirection: "column",
  };

  let commonActoinMessageButton = {
    height: "25%",
    marginBottom: "2%",
    marginTop: "6%",
  };
  useEffect(()=>{
    if(stiEmailData&&prospectDoc&&stiEmailData!="loading"){
    let tempEmailData = _.cloneDeep( stiEmailData);
    tempEmailData.renewalDate = findRenewalData(prospectDoc)
    setSubmissionEmailData(tempEmailData)
   }
  },[prospectDoc,stiEmailData])

  useEffect(() => {
   
    const handleResize = () => {
      setWindowSize(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    // Cleanup on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []); // Empty dependency array means this effect runs once on mount and cleans up on unmount

  const isLargeScreen = windowSize <= 1719;

  // Helper functions for French-friendly data
  const getLocalizedField = (field, lang = "en") => {
    if (!field) return "";
    if (typeof field === "string") return field; // Backward compatibility
    return field[lang] || field.en || field; // Language-aware with fallbacks
  };

  const buildOperationString = (operationList, lang = "en") => {
    if (!operationList) return "";
    if (typeof operationList === "string") return operationList; // Backward compatibility
    if (!Array.isArray(operationList)) return "";
    return operationList.map(op => 
      `-  ${op.id}: ${getLocalizedField(op.name, lang)} -`
    ).join("");
  };

  const getEmailBody = (lang = "en") => {
    if (lang === "fr") {
      return (
        "Bonjour, \n\n" +
        "Le lien sécurisé suivant vous dirigera vers un PDF contenant une soumission pour une demande de devis générée sur Quotey.io \n" +
        irs +
        "\n\n\n" +
        "Cette URL vous permettra de consulter les mêmes informations sur Quotey \n" +
        irsapp +
        "\n\n" +
        "Le client dispose également d'une copie de ces informations et nous obtiendrons une signature numérique avant de finaliser l'engagement. \n\n\n" +
        "J'attends avec impatience de vos nouvelles. En attendant, si vous avez des questions, vous pouvez me contacter au " +
        phonenumber +
        "\n\n\n" +
        "Merci \n" +
        name +
        "\n" +
        brokeragename +
        "\n\n\n" +
        "p.s. si vous souhaitez gagner du temps sur les demandes de devis et rejoindre la marketplace Quotey, visitez www.Quotey.io"
      );
    } else {
      return (
        "Hi, \n\n" +
        "The following secure link will take you to a PDF with submission for a quotation generated on Quotey.io \n" +
        irs +
        "\n\n\n" +
        "This URL will allow you to review the same information in Quotey \n" +
        irsapp +
        "\n\n" +
        "The client also has a copy of this information and we will obtain digital signature before binding. \n\n\n" +
        "I look forward to hearing from you. In the meantime, if you have any questions you can contact me on " +
        phonenumber +
        "\n\n\n" +
        "Thanks \n" +
        name +
        "\n" +
        brokeragename +
        "\n\n\n" +
        "p.s if you want to save time quoting and join the Quotey marketplace, visit www.Quotey.io"
      );
    }
  };
  
  const getEmailBodyV2 = (lang = "en") => {
    if (lang === "fr") {
      return `
  Bonjour,
  
  Veuillez trouver ci-joint une soumission pour notre client, complétée sur Quotey.io.
  
  Les détails récapitulatifs sont les suivants :
  
  Nom de l'entreprise: ${submissionEmailData.clientBusinessName}
      
  Adresse: ${submissionEmailData.clientAddress}
      
  Date de renouvellement: ${submissionEmailData.renewalDate}
      
  Secteur: ${getLocalizedField(submissionEmailData.verticalName, lang)}
      
  Opération(s): ${buildOperationString(submissionEmailData.operationList, lang)}
      
  ${submissionEmailData[69000]}
      
  J'attends vos retours avec impatience et j'espère que nous aurons l'opportunité de collaborer avec vous pour ce client.
  
  Si vous avez des questions, n'hésitez pas à me le faire savoir.
      
  Merci,
  
  ${name}
      `;
    } else {
      return `
  Hi,
  
  Please find attached a submission for our client, completed on Quotey.io.
  
  Summary details are as follows:
  
  Company name: ${submissionEmailData.clientBusinessName}
      
  Address: ${submissionEmailData.clientAddress}
      
  Renewal date: ${submissionEmailData.renewalDate}
      
  Vertical: ${getLocalizedField(submissionEmailData.verticalName, lang)}
      
  Operation(s): ${buildOperationString(submissionEmailData.operationList, lang)}
      
  ${submissionEmailData[69000]}
      
  I look forward to your thoughts and hope that we have an opportunity to work with you on this client.
  
  If you have any questions, please let me know.
      
  Thanks,
  
  ${name}
      `;
    }
  };
  

  const handleOption1Click = () => {
    // get all the insurer
    // if (emaillist.length === 0) {
    //   return toast.error("Select at least one insurer to send email!");
    // }

    const pdfLanguagePrefIsFrench =
    localStorage.getItem("pdfLanguagePrefIsFrench") === "true";
    const langSelected = pdfLanguagePrefIsFrench ? "fr" : "en"

    let emailString = emaillist.join(";");
    let emailBody = getEmailBodyV2(langSelected);
    let subject = pdfLanguagePrefIsFrench 
  ? `Nouvelle soumission pour ${submissionEmailData.clientBusinessName}` 
  : `New Submission for ${submissionEmailData.clientBusinessName}`;

    if (formstate?.j?.nodestate?.["69001"]?.answer) {
      setModalObj({
        show: true,
        documents: formstate.j.nodestate["69001"].answer,
        emailInfo: { emailString, emailBody, subject },
      });
    } else {
      const showTOC = localStorage.getItem("showTOC") === "true";
      const showAnsweredOnly =
        localStorage.getItem("showAnsweredOnly") === "true";

      // download the pdf and convert it to base64
      dispatch(updateProspectStatus({prospectid, statuscode:'in_market' }))
      dispatch(
        getPDFV2fromURL({
          id: irsCodeOnly,
          downloadingEml: true,
          mailto: email,
          bcc: emailString,
          body: emailBody,
          subject,
          include_toc: showTOC,
          show_empty_answers: showAnsweredOnly,
          pdf_language_selected: langSelected,
          client_name: (formstate?.a?.nodestate?.[10501]?.answer || formstate?.a?.nodestate?.[10507]?.answer || formstate?.a?.nodestate?.[10101]?.answer || "").trim(),
        })
      );

      toast.success(
        <div style={{ fontFamily: "GibsonRegular" }}>
          {externalTranslations[languagepreference].toastTranslation}
        </div>
      );
    }
  };

  const AddDocumentsModal = (props) => {
    var documents = [];
    return (
      <Modal
        size="md"
        isOpen={modalObj.show}
        ariaHideApp={false}
        shouldCloseOnEsc={true}
        centered
        style={{
          overlay: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: theme.COLORS.rgba_primary_navyblue,
          },
          content: {
            height: "35vh",
            width: "25vw",
            position: "absolute",
            top: "15vh",
            left: "29vw",
            background: "#eef3f6",
            WebkitOverflowScrolling: "touch",
            border: "8px solid " + theme.COLORS.white_Indo,
            borderRadius: "20px",
            padding: 0,
            overflow: "hidden",
            backgroundColor: theme.COLORS.primary_navyblue,
          },
        }}
      >
        <div style={{ position: "absolute", top: 10, right: 10 }}>
          <CancelIcon
            fontSize="large"
            style={{ cursor: "pointer", color: "white" }}
            onClick={() => {
              setModalObj({ show: false });
            }}
          ></CancelIcon>
        </div>
        <div>
          <div
            style={{
              width: "100%",
              height: "7vh",
              backgroundColor: theme.COLORS.secondary_skyblue,
              fontSize: "1.9vmin",
              letterSpacing: 1,
              display: "flex",
              justifyContent: "center",
              alignItems: "end",
              color: "white",
              fontFamily: "GibsonRegular",
            }}
          >
            {externalTranslations[languagepreference].uploadDocumentsTitle}
           
          </div>
          <div
            style={{
              height: "18vh",
              overflowY: "auto",
              display: "flex",
              flexDirection: "column",
              marginLeft: "6%",
              paddingTop: "10px",
            }}
          >
            {modalObj?.documents?.map((x, idx) => {
              return (
                <>
                  <Form.Check
                    inline
                    label={x.fileName}
                    style={{ color: "white" }}
                    name="group1"
                    type="checkbox"
                    id={`inline-checkbox-${idx}`}
                    onClick={(e) => {
                      if (e.target.checked) {
                        documents.push(x);
                      } else {
                        documents = documents.filter(
                          (doc) => doc.s3Upload.Etag != x.s3Upload.Etag
                        );
                      }
                      return;
                    }}
                  />
                  {}
                </>
              );
            })}
          </div>
        </div>
        {/* <button

          onClick={(e) => {
            
            dispatch(
              getPDFV2fromURL({
                id: irsCodeOnly,
                downloadingEml: true,
                mailto: email,
                bcc:  modalObj?.emailInfo?.emailString,
                body:  modalObj?.emailInfo?.emailBody,
                subject: modalObj?.emailInfo?.subject,
                additionalDocuments: documents
              })
            );
          }}
        >Send Email</button> */}
        <div
          style={{
            width: "50%",
            margin: "auto",
          }}
        >
          <ActionMessageButton
            text={""}
            style={{
              height: "20%",
              width: "50%",
              margin: "auto",
            }}
            buttonText={
              showLoading({ pdfstatus: pdfstatus }) ? (
                <Loading></Loading>
              ) : (
                externalTranslations[languagepreference].createEmailButtonText
              )
            }
            buttonClick={() => {
              const showTOC = localStorage.getItem("showTOC") === "true";
              const showAnsweredOnly =
                localStorage.getItem("showAnsweredOnly") === "true";
              const pdfLanguagePrefIsFrench =
                localStorage.getItem("pdfLanguagePrefIsFrench") === "true";
              dispatch(updateProspectStatus({prospectid, statuscode:'in_market' }))
              dispatch(
                getPDFV2fromURL({
                  id: irsCodeOnly,
                  downloadingEml: true,
                  mailto: email,
                  bcc: modalObj?.emailInfo?.emailString,
                  body: modalObj?.emailInfo?.emailBody,
                  subject: modalObj?.emailInfo?.subject,
                  additionalDocuments: documents,
                  include_toc: showTOC,
                  show_empty_answers: showAnsweredOnly,
                  pdf_language_selected: pdfLanguagePrefIsFrench ? "fr" : "en",
                  client_name: (formstate?.a?.nodestate?.[10501]?.answer || formstate?.a?.nodestate?.[10507]?.answer || formstate?.a?.nodestate?.[10101]?.answer || "").trim(),
                })
              );
            }}
            buttonTextSize="18px"
          ></ActionMessageButton>
        </div>
      </Modal>
    );
  };

  const handleOptionDownloadPdfClick = () => {
    const showTOC = localStorage.getItem("showTOC") === "true";
    const showAnsweredOnly =
      localStorage.getItem("showAnsweredOnly") === "true";
    const pdfLanguagePrefIsFrench =
      localStorage.getItem("pdfLanguagePrefIsFrench") === "true";

    // get all the insurer
    // if (emaillist.length === 0) {
    //   return toast.error("Select at least one insurer to send email!");
    // }

    // download the pdf and convert it to base64
    dispatch(updateProspectStatus({prospectid, statuscode:'in_market' }))
    dispatch(
      getPDFV2fromURL({
        id: irsCodeOnly,
        include_toc: showTOC,
        show_empty_answers: showAnsweredOnly,
        pdf_language_selected: pdfLanguagePrefIsFrench ? "fr" : "en",
        client_name: (formstate?.a?.nodestate?.[10501]?.answer || formstate?.a?.nodestate?.[10507]?.answer || formstate?.a?.nodestate?.[10101]?.answer || "").trim(),
      })
    );

    setTimeout(() => {
      dispatch(
        setautoreminder({
          text: externalTranslations[languagepreference].reminderText,
          title: externalTranslations[languagepreference].reminderTitle,
          prospectid,
          remindercategory:
            externalTranslations[languagepreference].reminderCategory,
        })
      );
    }, 500);

    toast.success(
      <div style={{ fontFamily: "GibsonRegular" }}>
        {externalTranslations[languagepreference].pdfDownloadedToast}
      </div>
    );
  };

  const handleOption2Click = () => {
    toast(
      <div style={{ fontFamily: "GibsonRegular" }}>
        {" "}
        {externalTranslations[languagepreference].buttonToast}
      </div>
    );
  };
  const alertForSelect = (arg) => {
    if (arg === 0) {
      toast(
        <div style={{ fontFamily: "GibsonRegular" }}>
          {externalTranslations[languagepreference].alertSelectOne}
        </div>
      );
    } else {
      toast(
        <div style={{ fontFamily: "GibsonRegular" }}>
          {externalTranslations[languagepreference].alertSelectOnlyOne}
        </div>
      );
    }
  };

  const onBindModalOpenHandler = () => {
    if (validateBeforeSendBind.length === 0) {
      alertForSelect(0);
    } else if (validateBeforeSendBind.length > 1) {
      alertForSelect(1);
    } else {
      dispatch(bindModalOpened());
    }
  };

  let history = useNavigate();
  let navigate = useNavigate();
  const totalSelected = useSelector(getTotalSelected);
  const buttonTextDecider = ({ totalSelected }) => {
    if (totalSelected === 0)
      return translations[languagepreference].viewOrCompare;
    if (totalSelected > 1)
      return translations[languagepreference].compareSelectedProducts;
    return translations[languagepreference].viewSelectedProduct;
  };

  const ccpClickHandle = () => {
    if (totalSelected > TotalNumberOfComparisonInsurerPDFCanHandle) {
      toast(
        <div>
          {externalTranslations[languagepreference].quoteComparisonToastMessage.replace('{maxQuotes}',TotalNumberOfComparisonInsurerPDFCanHandle)}
          
        </div>,
        { position: "top-center" }
      );
    } else {
      dispatch(updateSTCModalStatus({ status: true }));
    }
  };

  const stcModalStatus = useSelector(getSTCModalStatus);
  const pdfstatus = useSelector(getPDFV2status);
  const pdfonlystaus = useSelector(getPDFOnlyStatus);
  var timer = null;
  const showLoading = ({ pdfstatus }) => {
    if (pdfstatus === PossibleApiStatusValues.loading) return true;

    return false;
  };

  React.useEffect(() => {
    if (pdfstatus == "success") {
      // once pdf is loaded we close the modal
      setModalObj({ show: false });
    }
  }, [pdfstatus]);

  const Loading = () => {
    return (
      <ReactLoading
        type={"bars"}
        color={"white"}
        height={"70%"}
        width={"10%"}
      />
    );
  };

  const copyToClipboard = (text) => {
    let dummy = document.createElement("textarea");
    document.body.appendChild(dummy);
    dummy.value = text;
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);
  };

  const handleClickToCopyText = () => {
    copyToClipboard(irsapp);
    toast.success(externalTranslations[languagepreference].wholeLinkCopied, {
      autoClose: 1500,
      position: "top-center",
    });
  };

  const policyJustBinded = useSelector(getPolicyJustBinded);
  var disableBindButton = false;
  if (userHasPermission(bindPermission) == false) {
    disableBindButton = true;
  }
  if (gotProspectDetails === true || policyJustBinded) {
    disableBindButton = true;
  }
  return (
    <React.Fragment>
      {showingSendToInsurers ? (
        <div
          style={{
            ...common,
            paddingBottom: "17vh",
            paddingTop: "6vh",
            paddingLeft: theme.SCALES.actionPaddingLeft,
            paddingRight: theme.SCALES.actionPaddingRight,
            height: "100%",
          }}
        >
          <ActionCentreText></ActionCentreText>
          <div>
            <FormControl
              sx={{ m: 0, minWidth: 260 }}
              style={{ marginTop: "20px" }}
            >
              <div>
                <input
                  id="txtQuery"
                  placeholder={
                    translations[languagepreference]?.searchForInsurer
                  }
                  style={{
                    backgroundColor: "#ffffff",
                    width: "80%",
                    display: "inline-flex",
                    borderStartEndRadius: "0px",
                    borderEndEndRadius: "0px",
                  }}
                  className="form-control"
                  onChange={(event) => {
                    let new_results = initial_insureorder.filter((x) =>
                      x.toLowerCase().includes(event.target.value.toLowerCase())
                    );
                    let new_results2 = initial_insureorderInverse.filter((x) =>
                      x.toLowerCase().includes(event.target.value.toLowerCase())
                    );
                    if (new_results || new_results2) {
                      clearTimeout(timer);
                      timer = setTimeout(() => {
                        dispatch(updateInsurerOrder(new_results));
                        dispatch(updateInsurerOrderInverse(new_results2));
                      }, 700);
                    }
                  }}
                />
                <div
                  style={{
                    display: "inline-flex",
                    paddingLeft: "3.5%",
                    paddingTop: "6px",
                    paddingRight: "3.5%",
                    backgroundColor: theme.COLORS.secondary_skyblue,
                    borderStartEndRadius: "5px",
                    borderEndEndRadius: "5px",
                  }}
                >
                  <label>🔍</label>
                </div>
              </div>
            </FormControl>
          </div>

          <div style={{ ...commonActoinMessageButton }}>
            <div
              style={{
                width: "100%",
                height: "67%",
                display: "flex",
                alignItems: "flex-end",
                // marginBottom: 10,
              }}
            >
              <div>
                <p
                  style={{
                    color: "grey",
                    fontFamily: "GibsonRegular",
                    fontSize: "1.3vmin",
                    lineHeight: "1.5",
                    marginBottom: "9px",
                  }}
                >
                  {translations[languagepreference]?.downloadPDF.text}
                </p>
              </div>
            </div>

            <DropdownButton
              style={{
                width: "100%",
                height: "33%",
                fontSize: "min(max(0.7vw, 10px), 0.8vw)",
              }}
              className="custom-dropdown-button-2"
              // variant="warning"
              title={translations[languagepreference]?.sendToSelectedInsurers}
              id="bg-nested-dropdown"
              // show={dropdownOpen}
              drop={"up"}
              // onToggle={handleDropdownToggle}
            >
              <Dropdown.Item
                style={{
                  width: "100%",
                }}
                eventKey="0"
                onClick={() => {
                  // setuseEmail(false);
                  setIsModalOpen(true);
                }}
              >
                {translations[languagepreference]?.editPDFOptions}
              </Dropdown.Item>
              <Dropdown.Item
                style={{
                  width: "100%",
                }}
                eventKey="1"
                onClick={() => {
                  // setuseEmail(false);
                  // setIsModalOpen(true);
                  handleOptionDownloadPdfClick();
                }}
              >
                {translations[languagepreference]?.downloadPDFButtonText}
              </Dropdown.Item>
              <Dropdown.Item
                style={{
                  width: "100%",
                }}
                eventKey="2"
                onClick={() => {
                  // setuseEmail(false);
                  handleOption1Click();
                }}
              >
                {translations[languagepreference]?.createEmailWithApplication}
              </Dropdown.Item>
            </DropdownButton>
          </div>
          <div style={{ ...commonActoinMessageButton }}>
            <ActionMessageButton
              text={translations[languagepreference]?.externalLink.text}
              buttonText={
                translations[languagepreference]?.externalLink.buttonText
              }
              buttonClick={handleClickToCopyText}
              buttonTextSize="min(max(0.7vw,10px),0.8vw)"
            />
          </div>
          {/* <div style={{ ...commonActoinMessageButton }}>
            <ActionMessageButton
              text={
                "Edit PDF settings to toggle the table of contents and display of empty answers."
              }
              buttonText={"Edit the information on the PDF"}
              buttonClick={() => setIsModalOpen(true)}
              buttonTextSize="min(max(0.7vw,10px),0.8vw)"
            ></ActionMessageButton>
          </div> */}
          <AddDocumentsModal></AddDocumentsModal>
          <PdfSettingsModal
            open={isModalOpen}
            onClose={() => setIsModalOpen(false)}
          />
        </div>
      ) : (
        <div
          style={{
            ...common,
            paddingBottom: "5vh",
            paddingTop: "6vh",
            paddingLeft: "15%",
            paddingRight: "12%",
            height: "100%",
          }}
        >
          <ActionCentreText></ActionCentreText>
          <div style={{ ...commonActoinMessageButton }}>
            <ActionMessageButton
              text={
                totalSelected === 0
                  ? translations[languagepreference].productComparison
                      .noSelection
                  : translations[languagepreference].productComparison
                      .selectionMade
              }
              buttonText={buttonTextDecider({ totalSelected })}
              buttonClick={() => {
                // pb.viewdetialsinfor.clicked = false;
                // pb.CompareModalTFncs.showModal(true);
                // cv stands for compare or view
                document.location.href = `/cv?id=${prospectid}`;
                //navigate(`/cv?id=${prospectid}`);
              }}
              disabled={totalSelected === 0 ? true : false}
            ></ActionMessageButton>
          </div>
          <div style={{ ...commonActoinMessageButton }}>
            <ActionMessageButton
              text={translations[languagepreference].insurerSubmission.text}
              disabled={!userHasPermission(goToMarketPermission)}
              buttonText={
                translations[languagepreference].insurerSubmission.buttonText
              }
              buttonClick={() => {
                document.location.href = `/sti?id=${prospectid}`;
                //navigate(`/sti?id=${prospectid}`);
              }}
            ></ActionMessageButton>
          </div>
          <div style={{ ...commonActoinMessageButton }}>
            <ActionMessageButton
              text={translations[languagepreference].sendToClient.text}
              buttonText={
                translations[languagepreference].sendToClient.buttonText
              }
              disabled={!gettingMyQuotesSucceed}
              buttonClick={ccpClickHandle}
            ></ActionMessageButton>
            <SendToClientModal
              isopen={stcModalStatus}
              popupHeight={85}
              popupWidth={80}
              insurerId={
                validateBeforeSendBind.length > 0 && validateBeforeSendBind
              }
            ></SendToClientModal>
          </div>
          {/* <div style={{ ...commonActoinMessageButton }}>
            <ActionMessageButton
              text={
                "Download a PDF containing all the application questions and answers"
              }
              buttonText={
                showLoading({ pdfstatus: pdfonlystaus }) ? (
                  <Loading></Loading>
                ) : (
                  "Download application PDF"
                )
              }
              buttonClick={handleOptionDownloadPdfClick}
              buttonTextSize="min(max(0.7vw,10px),0.8vw)"
            ></ActionMessageButton>
          </div> */}
          <div style={{ ...commonActoinMessageButton, marginTop: "6%" }}>
            <div
              style={{
                width: "100%",
                height: "67%",
                display: "flex",
                alignItems: "flex-end",
                // marginBottom: 10,
              }}
            >
              <div>
                <p
                  style={{
                    color: "grey",
                    fontFamily: "GibsonRegular",
                    fontSize: "1.3vmin",
                    lineHeight: "1.5",
                    marginBottom: "9px",
                  }}
                >
                  {translations[languagepreference].downloadPDF.text}
                </p>
              </div>
            </div>

            <DropdownButton
              style={{ width: "100%", height: "33%" }}
              className="custom-dropdown-button-2"
              // variant="warning"
              title={translations[languagepreference].downloadPDF.buttonText}
              id="bg-nested-dropdown"
              // show={dropdownOpen}
              drop={"up"}
              // onToggle={handleDropdownToggle}
            >
              <Dropdown.Item
                style={{
                  width: "100%",
                }}
                eventKey="1"
                onClick={() => {
                  // setuseEmail(false);
                  setIsModalOpen(true);
                }}
              >
                {translations[languagepreference]?.editPDFOptions}
              </Dropdown.Item>
              <Dropdown.Item
                style={{
                  width: "100%",
                }}
                eventKey="1"
                onClick={() => {
                  // setuseEmail(false);
                  // setIsModalOpen(true);
                  handleOptionDownloadPdfClick();
                }}
              >
                {translations[languagepreference]?.downloadPDFButtonText}
              </Dropdown.Item>
            </DropdownButton>
          </div>
          <PdfSettingsModal
            open={isModalOpen}
            onClose={() => setIsModalOpen(false)}
          />
        </div>
      )}
    </React.Fragment>
  );
};

export default RightPaneActions;
